import { useTranslation } from 'react-i18next';

import { Dialog, HtmlPreview } from '~/components';

import { previewDialogStyle } from './InvoicePreviewDialog.css';

type Props = {
  html: string | undefined;
  onClose: () => void;
  title: string | null;
};

export const InvoicePreviewDialog = ({ html, onClose, title }: Props) => {
  const { t } = useTranslation(['invoices']);

  return (
    <Dialog.Root onOpenChange={(open) => !open && onClose()} open={html !== undefined}>
      <Dialog.Body className={previewDialogStyle}>
        <Dialog.Header title={title ?? undefined} />

        {html !== undefined && <HtmlPreview html={html} title={title ?? t('invoices:overview.rowActions.preview')} />}
      </Dialog.Body>
    </Dialog.Root>
  );
};
